import { defineStore } from "pinia"
import useConvertDate from "@/composables/useConvertDate"
import type { Language, TimeZone } from "@/types/preferences"

const { currentTimeZone } = useConvertDate()

export const usePreferences = defineStore("preferences", {
  state: () => {
    return {
      language: localStorage.getItem("lang") || "en",
      theme: "dark",
      timeZone: currentTimeZone
    }
  },

  actions: {
    setLanguage(lang: Language) {
      this.language = lang
      localStorage.setItem("lang", lang)
    },

    setTimeZone(timezone: TimeZone) {
      this.timeZone = timezone
      localStorage.setItem("timeZone", timezone)
    }

    // setTheme(color: Preferences.Theme) {
    //   this.theme = color
    // }
  }
})
